import u_lerp from '../util/u_lerp';

export default class Cursor {
  private mouseX: number;
  private mouseY: number;
  private _currentMouseX: number[];
  private _currentMouseY: number[];
  private _preMouseX: number;
  private _preMouseY: number;
  private _startTime: number = null;
  private _lastPosition = { x: null, y: null };
  private _isMouseMoving: boolean = false;
  private _inactivityTime: number = 0;

  constructor() {
    // 未入力時の起点を画面中央に揃える（NDC変換で 0,0 を返すため）
    const cx = window.innerWidth / 2;
    const cy = window.innerHeight / 2;
    this.mouseX = cx;
    this.mouseY = cy;
    this._currentMouseX = [cx, cx, cx, cx, cx, cx];
    this._currentMouseY = [cy, cy, cy, cy, cy, cy];
    this._preMouseX = cx;
    this._preMouseY = cy;

    // イベントリスナーでmousemoveを監視
    window.addEventListener('mousemove', this.updateMousePosition.bind(this));
    window.addEventListener('touchmove', this.updateTouchPosition.bind(this), { passive: true });
  }

  // マウスの位置を更新するメソッド
  private updateMousePosition(event: MouseEvent): void {
    this.mouseX = event.clientX;
    this.mouseY = event.clientY;
  }
  private updateTouchPosition(event: TouchEvent): void {
    const touch = event.touches[0]; // 1本目の指の座標を取得
    this.mouseX = touch.clientX;
    this.mouseY = touch.clientY;
  }

  // 現在のマウス座標を取得するメソッド
  public getPosition(): { x: number, y: number } {
    return { x: this.mouseX, y: this.mouseY };
  }
  public getVector(){
    const vecX = this.mouseX -this._preMouseX;
    const vecY = this.mouseY -this._preMouseY;
    this._preMouseX = this.mouseX;
    this._preMouseY = this.mouseY;
    return {
      x:vecX/window.innerWidth,
      y:1-vecY/window.innerHeight
    }
  }
  public startTimer(){
    let currentPosition = { x: this.mouseX, y: this.mouseY };

    if (this._lastPosition.x !== currentPosition.x || this._lastPosition.y !== currentPosition.y) {
      // 位置が変わった場合
      if (!this._isMouseMoving) {
        this._isMouseMoving = true;
        this._startTime = performance.now();
        // console.log("Mouse started moving...");
      }
      this._lastPosition = currentPosition;
      this._inactivityTime += 100;  // 動きがあったので、停止時間をリセット
    } else {
      // 位置が同じ場合、動きがないとカウント
      this._inactivityTime = 0;  // 100ミリ秒ごとにチェック
    }

    // 一定時間動かなかったらカウントを停止
    if (this._inactivityTime >= 3000) {  // 例えば、3秒間動かなかった場合
      if (this._isMouseMoving) {
        let duration = (performance.now() - this._startTime) / 1000;  // 秒数に変換
        // console.log(`Mouse was moving for ${duration} seconds.`);
        this._isMouseMoving = false;
      }
    }
  }
  getMovingTime(){
    return this._inactivityTime;
  }
  // 正規化した座標を取得するメソッド
  public getNormalizedPosition(): { x: number, y: number } {
    return {
      x: (this.mouseX / window.innerWidth)* 2 - 1,
      y: -(this.mouseY / window.innerHeight)* 2 + 1
    };
  }
  public getCurrentMousePosition(index=0,delay=0.08): { x: number, y: number } {
    let targetX = 0;
    let targetY = 0;

    if (index === 0) {
      targetX = this.mouseX;
      targetY = this.mouseY;
    } else {
      targetX = this._currentMouseX[index - 1];
      targetY = this._currentMouseY[index - 1]; // ✅ Yも正しく参照
    }

    this._currentMouseX[index] = u_lerp(this._currentMouseX[index], targetX, delay);
    this._currentMouseY[index] = u_lerp(this._currentMouseY[index], targetY, delay);

    return {
      x: (this._currentMouseX[index] / window.innerWidth)  * 2 - 1,
      y: -(this._currentMouseY[index] / window.innerHeight) * 2 + 1,
    };
  }
}
